export function requiredValidation(val:any){
    if(val){
        return true;
    }
    return false;
}

export function isNegative(val:any){
    if(val){
        if(Number(val)){
            if(Number(val)<0)
                return true;
            return false;
        }
        return false;
    }
    return false;
}

export function isPositive(val:any){
    if(val){
        if(Number(val)){
            if(Number(val)>0)
                return true;
            return false;
        }
        return false;
    }
    return false;
}

export function numberTbdValidation(e:any){
    if(e.value){
        let val = e.value.toString().trim().toUpperCase();
        if (val!='TBD' && !(Number(val) || (Number(val)==0))){
          return false;
        }
        return true;
    }
    return true;
}

export function removeDollarAndComma(val:string){
    if(!val)
        return val;
    val = val.toString().trim().toUpperCase();
    if(!val || val==''){
        return val;
    }
    else if(Number(val) || Number(val)==0){
        return val;
    }
    else{
        let amt='';
        let ar = val.split('');
        // if(val[0]!='$')
        // console.log(ar);
        
        let len = ar.length;
        ar.forEach((e,i) => {
            if(i==0 && e=='$'){}
            else if((i==0 || i==1) && e=='(' && ar[len-1]==')'){
                amt+='-';
                ar[len-1]='';
            }
            else{
                if(!['$',',',].includes(e))
                    amt+=e;
            }
        });
        // for(let i of val){
        //     if(!['$',','].includes(i))
        //         amt+=i;
        // }
        // console.log(amt);
        
        return amt;
    }
}

export function amountTbdValidation(e:any){
    if(e.value){
        let val = removeDollarAndComma(e.value);
        if(!val || val=='')
            return true;
        else if(val=='TBD')
          return true;
        else if(Number(val) || Number(val)==0)
            return true;
        else{
            return false;
        }
    }
    return true;
}

export function dateCompletedTbdNaValidation(e:any){
    let val = e.value.toString().trim().toUpperCase();
    if(val){
        if(val=='N/A'){
            return true
        }
        else {
            return dateCompletedTbdValidation(e);
        }
    }
    return true
}

export function dateCompletedTbdValidation(e:any){
    let val = e.value.toString().trim().toUpperCase();
    if(val){
        if(val=='COMPLETED'){
            return true
        }
        else {
            return dateTbdValidation(e);
        }
    }
    return true
}

export function dateTbdNaValidation(e:any){
    let val = e.value.toString().trim().toUpperCase();
    if(val){
        if(val=='N/A'){
            return true;
        }
        else {
            return dateTbdValidation(e);
        }
    }
    return true;
}

export function dateTbdValidation(e:any){
    let val = e.value.toString().trim().toUpperCase();
    if(val){
        if(val=='TBD'){
            return true;
        }
        else {
            return checkDate(val);
        }
    }
    return true;
}

export function numberValidation(e:any){
    if(e.value){
        let val = e.value.toString().trim();
        if (Number(val) || (Number(val)==0)){
          return true;
        }
        return false;
    }
    return true;
}

export function amountValidation(e:any){
    if(e.value){
        let val = removeDollarAndComma(e.value);
        if (Number(val) || (Number(val)==0)){
          return true;
        }
        return false;
    }
    return true;
}

export function checkDate(date:any){ 

    let [m,d,y]=date.split('/');

    if(!m || !d || !y || m.length!=2 || d.length!=2 || y.length!=2){
        return false
    }

    if(!Number(m) || !Number(d) || !Number(y)){
        return false;
    }
    
    let temp:any = new Date(date);

    if(m-1 != temp.getMonth()){
        return false;
    }
    
    if(temp == "Invalid Date"){
        return false
    }
    
    return true;
}